import {useIntl} from 'react-intl';
import {Button} from 'react-bootstrap';
import {MouseEventHandler} from 'react';
import clsx from 'clsx';
import {ButtonSize} from '../../types/Forms';

interface ButtonResetProps {
    onClick?: MouseEventHandler<HTMLButtonElement> | undefined;
    textId: string;
    size?: ButtonSize;
}

const ButtonReset = ({onClick, textId, size}: ButtonResetProps): JSX.Element => {
    const intl = useIntl();

    return (
        <Button
            type="reset"
            variant="secondary"
            className={clsx({
                'btn-sm': size === 'small',
                'btm-lg': size === 'large',
            })}
            onClick={onClick}
        >
            {intl.formatMessage({id: textId})}
        </Button>
    );
};

export default ButtonReset;
